module.exports = __webpack_public_path__ + "static/media/undraw_studying_re_deca.b6385905.svg";